<div class="row">
    <div class="col-md-6 col-lg-6 col-xl-5 col-12 mx-auto">
        <div *ngIf="!showType" class="text-center">

            <div class="mb-3">
                <img style="width:86px;height:auto" src="/assets/logo.png" class="img">
            </div>

            <div class="mb-1 fs-4 fw-bold">
                CANTAB Test
            </div>

            <div class="text-muted" style="white-space: pre-wrap;">
                {{data.info}}
            </div>

            <div class="d-flex position-relative show-type text-center flex-column justify-content-center">
                <div class="pt-5 px-md-5">
                    <a [class.disabled]="isStarted!=1" class="btn btn-start w-100" routerLink="play">
                        {{isStarted!=1?'Test hasn\'t started yet':'Start'}}
                    </a>
                </div>
            </div>

            <div class="mt-4 d-flex mb-2 px-md-5 text-start">
                <div class="card bg-light rounded-4 w-100">
                    <div class="card-body p-1">
                        <div class="disclaimer">
                            <div class="d-flex align-items-center px-1">
                                <div class="pe-3">
                                    <img src="/assets/disclaimer.svg">
                                </div>
                                <div>
                                    <div class="fw-bold">Disclaimer</div>
                                    <div class="text-muted font-book">
                                        This trial test adopted from CANTAB Test in
                                        <a href="https://www.cambridgecognition.com" class="text-primary" target="_blank">
                                            https://www.cambridgecognition.com
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>
